import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

interface IGetAllFoundDescendants {
  competitors: ISobCompetitor[]
  parentId: string
  competitorId: string
}
export const getAllFoundDescendants = ({
  competitors,
  competitorId,
  parentId,
}: IGetAllFoundDescendants) => {
  const descendants: ISobCompetitor[] = []

  function collectDescendants(id: string) {
    const directChildren = competitors.filter(
      (comp) => comp.ParentId === id && comp.CompetitorID === competitorId
    )
    directChildren.forEach((child) => {
      descendants.push(child)
      collectDescendants(child.EntryId)
    })
  }

  collectDescendants(parentId)
  return descendants
}
